import Vue from 'vue'
import Vuex from 'vuex'
// import homeIndex from './homeIndex'
import userIndex from './userIndex'
// import novelIndex from './novelIndex'
Vue.use(Vuex)
export default new Vuex.Store({
    modules: {
        // homeIndex,
        userIndex,
        // novelIndex
    }
})